import React from 'react';
import { useTranslation } from 'react-i18next';
import { Phone, MapPin, Mail } from 'lucide-react';
import PageBanner from '../layout/PageBanner';
import TeamSection from '../element/TeamSection';
import TouchStart from '../components/TouchStart';

const contactInfo = [
    { Icon: Phone,   color: '#d89d37', key: 'callNow',      href: 'tel:+34614005838',          value: '+34 614 005 838' },
    { Icon: MapPin,  color: '#5370e2', key: 'location',     href: null,                         value: 'Los Alcázares, Murcia, Spain' },
    { Icon: Mail,    color: '#47b5b9', key: 'emailAddress', href: 'mailto:geral@purekeyhomes.es', value: 'geral@purekeyhomes.es' },
];

const ContactUs = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageBanner parentPage={t('contactPage.parentPage')} activePage={t('contactPage.activePage')} motherMenu={t('contactPage.motherMenu')} />

            <div className="main-contact-page-link">
                <div className="container">
                    <div className="row contact-info-row">
                        {contactInfo.map((item) => {
                            const { Icon, color, key, href, value } = item;

                            return (
                                <div
                                    className="col-xl-4 col-lg-6 col-12"
                                    key={key}
                                >
                                    <div className="contact-page-card">
                                        <div className="contact-page-card-icon" style={{ background: `${color}18` }}>
                                            <Icon size={24} color={color} strokeWidth={2} />
                                        </div>
                                        <div className="contact-page-card-text">
                                            <h3 className="h3-title">{t(`contactPage.${key}`)}</h3>
                                            <p>
                                                {href
                                                    ? <a href={href}>{value}</a>
                                                    : value
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="contact-map">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25239.27532768915!2d-0.8680711288084981!3d37.745269292598095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd6313743acfd8db%3A0x1d22a606fca7b365!2sLos%20Alc%C3%A1zares%2C%20Murcia!5e0!3m2!1spt-PT!2ses!4v1767119189714!5m2!1spt-PT!2ses"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>

            <section className="main-contact page-inner-contact">
                <div className="container">
                    <TouchStart />
                </div>
            </section>

            <section className="main-team contact-page-team">
                <TeamSection />
            </section>
        </>
    );
};

export default ContactUs;